import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, Select, Table, ToggleSwitch, ProgressBar } from "@gpstrackit/react-controls";
import { Grid } from "@mui/material";
import CustomSelect from 'Components/Select';
import { NotificationManager } from "Components/Notifications";

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';

import {
    bulkAddDriverIdTagsValidateIds,
    bulkAddDriverIdTagsImport,
    searchEntityRequest,

    clearRedux,
} from 'Redux/actions';

import './index.scss'


const BulkAddDriverIdTags = (props) => {

    const { messages } = useIntl();
    const { principalTableRef } = props;
    const dispatch = useDispatch();
    const stepOne = useRef(null);
    const stepTwo = useRef(null);
    const tableRef = useRef(null);
    const formRef = useRef(null);

    const [step, setStep] = useState(props.fromAccount ? 2 : 1);

    const [account, setAccount] = useState(props.account || null);
    const [ids, setIds] = useState([]);
    const [keyFobModel, setKeyFobModel] = useState(null);

    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux);
    const { keyFobModels } = useSelector(state => state.generalRedux);
    const loadingKeyFobModels = useSelector(state => state.generalRedux.loading);

    const [idSearchCriteria, setIdSearchCriteria] = useState("");
    const [validateIdsUsed, setValidateIdsUsed] = useState(false);

    const {
        openModal,
        loading,
        validationResult,
        importResult
    } = useSelector(state => state.bulkAddDriverIdTagsRedux);

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    const accountHandler = (newaccount) => {
        setAccount(newaccount);
    }

    const closeModal = () => {
        if(step === 3 && principalTableRef){
            principalTableRef?.current?.getData();
        }
        dispatch(clearRedux("BULK_ADD_DRIVERID_TAGS"));
        setAccount(null);
    }

    const handleSteps = () => {
        if (step === 1) {
            stepOne?.current?.submit();
        } else if (step === 2 && !validateIdsUsed) {
            dispatch(bulkAddDriverIdTagsValidateIds(ids.map(a => a.id)))
        } else if (step === 2 && validateIdsUsed && ids.filter(x => !x.used).length > 0) {
            dispatch(bulkAddDriverIdTagsImport({
                companyId: account.id, keyFobs: ids.filter(x => !x.used).map(item => {
                    return {
                        hex: item.id,
                        keyFobModelId: item.keyFobModelId
                    }
                })
            }))
        }
    }


    useEffect(() => {
        (!keyFobModels || (keyFobModels && keyFobModels.length === 0)) && dispatch(searchEntityRequest({ key: "keyFobModels" }));
    }, []);

    useEffect(() => {
        if (validationResult) {
            dispatch(clearRedux("BULK_ADD_DRIVERID_TAGS", { validationResult: null }))
            let markedIds = []//bulk_add_driver_tag_already_in_use
            markedIds = ids.map((item) => {
                if (validationResult.find(x => x.hex === item.id))
                    return { ...item, used: true }
                else
                    return item
            })

            setIds(markedIds)
            setValidateIdsUsed(true)

        }

        if (importResult) {
            //dispatch(clearRedux("BULK_ADD_DRIVERID_TAGS", { importResult: null }))
            setStep(3)

        }
    }, [validationResult, importResult]);

    return (
        <Modal
            open={openModal}
            title={messages['bulk_add_driver_tag_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
        >

            <ModalBody style={{ height: step === 1 && '70%' }}>
                <div style={{ width: '100%' }}>
                    <ProgressBar steps={3} activeStep={step} />
                </div>
                <div style={{ padding: '0 10px' }}>
                    {
                        step === 1 &&
                        <Form
                            ref={stepOne}
                            onValidSubmit={() => {
                                if (!account?.id) {
                                    NotificationManager.warning(
                                        messages['bulk_add_driver_tag_is_necessary_to_select_an_account'],
                                        messages['bulk_add_driver_tag_title'],
                                        3000
                                    );
                                } else setStep(2);
                            }}
                        >
                            <CustomSelect
                                async
                                value={account}
                                onChange={(items) => accountHandler(items)}
                                label={messages['bulk_add_driver_tag_account']}
                                loadOptions={getAccountsForSelect}
                                loading={loadingAccounts}
                                required
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}
                            />
                        </Form>
                    }
                    {
                        step === 2 &&
                        <Grid container spacing={2}>
                            <Grid item xs={12} style={{ marginTop: '10px' }}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => {
                                        let currentIds = ids;
                                        let errors = []
                                        let idSearchCriteriaArr = idSearchCriteria.split(/[\s,;\t\n]+/);
                                        let validateDuplicate = false
                                        let criterias = [];

                                        idSearchCriteriaArr.forEach(criteria => {
                                            let escCriteria = criteria.trim();

                                            let regx = /[^a-zA-Z0-9]/g;
                                            escCriteria = escCriteria.replace(regx, '');

                                            if (currentIds && currentIds.length) {

                                                let validate = currentIds.some((de) => de.id === escCriteria);

                                                if (!validate)
                                                    criterias.push(escCriteria);
                                                else
                                                    validateDuplicate = true;


                                            } else {

                                                criterias.push(escCriteria);
                                            }
                                        });

                                        criterias = [...new Set(criterias)];

                                        criterias.map((item) => {
                                            if (item.length > 0) {
                                                let currentKeyFobModel = keyFobModel
                                                currentIds.push({
                                                    id: item,
                                                    keyFobModelId: currentKeyFobModel.id,
                                                })
                                            }
                                        })
                                        setIds([...currentIds]);
                                        setIdSearchCriteria("");
                                        setValidateIdsUsed(false);
                                        if (validateDuplicate)
                                            NotificationManager.error(messages["bulk_add_driver_tag_repeated_in_list"], messages['bulk_add_driver_tag_title'], 6000, null, null, '', null);

                                    }}
                                >
                                    <Grid container>
                                        <Grid item xs={5} style={{ marginLeft: 10 }}>
                                            <Input
                                                type="text"
                                                id="id"
                                                label={messages["bulk_add_driver_tag_id"]}
                                                placeholder={messages["bulk_add_driver_tag_id"]}
                                                value={idSearchCriteria || ''}
                                                onChange={(value) => {
                                                    setIdSearchCriteria(value)
                                                }}
                                                onKeyPress={event => {
                                                    if (event.key === 'Enter') {
                                                        focusNextControl(event);
                                                    }
                                                }}

                                                noBlurValidation
                                                maxLength={4000}
                                                required
                                                requiredMessage={messages['required_field']}
                                                autoComplete="new-password"
                                            />
                                        </Grid>
                                        <Grid xs={4} style={{ marginLeft: 10 }}>
                                            <Select
                                                id="key-fob-model"
                                                name="KeyFobModel"
                                                label={messages["bulk_add_driver_tag_model"]}
                                                placeholder={messages["bulk_add_driver_tag_model"]}
                                                value={keyFobModel}
                                                onChange={(value) => {
                                                    setKeyFobModel(value);
                                                }}
                                                options={keyFobModels}
                                                loading={loadingKeyFobModels}
                                                textField="name"
                                                valueField="id"
                                                required
                                                requiredMessage={messages['common_field_required']}
                                            />
                                        </Grid>

                                        <Grid xs={2} style={{ marginLeft: 10, marginTop: 25 }}>
                                            <Button
                                                id="btnAdd"
                                                className="btn-dark-blue"
                                                onClick={(event) => {
                                                }}
                                            >
                                                {messages['common_add']}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Form>
                            </Grid>
                            <Grid item xs={12} style={{ marginLeft: 10, marginTop: 10 }}>
                                <Table
                                    ref={tableRef}
                                    columns={[
                                        {
                                            key: "id",
                                            title: messages['bulk_add_driver_tag_id'],
                                            width: 150,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span>{item?.id}</span>
                                                )
                                            }
                                        },
                                        {
                                            key: "message",
                                            title: messages['bulk_add_driver_tag_message'],
                                            width: 200,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span className={item?.used ? "fg-danger" : "fg-success"}>{item?.used ? messages["bulk_add_driver_tag_already_in_use"] : validateIdsUsed ? messages["bulk_add_driver_tag_ready_to_import"] : ""}</span>
                                                )
                                            }
                                        }
                                    ]}
                                    data={ids}
                                    height={380}
                                    hidePagination
                                    disableItemSelection
                                />
                            </Grid>
                        </Grid>
                    }
                    {
                        step === 3 &&
                        <Grid container spacing={2}>
                            <Grid item xs={12} style={{ marginTop: '10px' }}>
                                <span>{`${importResult}  ${messages["bulk_add_driver_tag_import_message"]}`} </span>
                            </Grid>
                        </Grid>
                    }
                </div>
            </ModalBody>

            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
                {
                    ((step === 2) || step === 3) && !importResult &&
                    <Button
                        style={{ backgroundColor: '#e4e4e4' }}
                        className="btn-cancel"
                        onClick={() => {
                            setStep(step - 1)
                        }}
                    >
                        {messages['common_back']}
                    </Button>
                }
                {
                    !importResult &&
                    <Button
                        className="btn-dark-blue"
                        onClick={() => handleSteps()}
                    >
                        {(step === 2 && validateIdsUsed) ? messages['common_save'] : messages['common_next']}
                    </Button>
                }
            </ModalFooter>
        </Modal>
    )
}

export default BulkAddDriverIdTags;